import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import theme, { applyTheme } from "./themes";

// ── Apply static theme before first paint (overridden per-user after login) ───
applyTheme(theme);

// ── Render ────────────────────────────────────────────────────────────────────

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
